// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"596":"d8ab9771","636":"8d883377","654":"cf62cedb","766":"7e373a50","877":"6393fef8"}[chunkId] + ".css";
};